import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ISeed } from "../types/seed";

const API = process.env.REACT_APP_API;

const useUpdateSeed = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (seed: ISeed) => {
      return fetch(`${API}/api/update-seed`, {
        method: "PATCH",
        body: seed,
      });
    },
    onError: (error) => {
      console.log("onError", error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["seed"] });
    },
  });
};

export default useUpdateSeed;
